import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Component, EventEmitter, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { NotificationmodalComponent } from 'src/app/notificationmodal/notificationmodal.component';
import { AgentscriptService_updated } from 'src/app/services/agent-script-service/agent-script-service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent {

  @Output() componentSelection = new EventEmitter<any>();

  backendUrl = environment.apiURL;

  constructor(private http:HttpClient,public dialog: MatDialog,private agentscriptservice:AgentscriptService_updated){}
  ngOnInit()
  {
    console.log('in notifications')
    this.agentscriptservice.getusernotifications();
    // this.getuserallnotifications();
    this.agentscriptservice.getNotificationsCountOfUnRead()
    // this.getNotificationsCountOfUnRead()
    this.getnotificationscount();
  }

  openModalPopup(): void {
    const dialogRef = this.dialog.open(NotificationmodalComponent, {
      width: '740px'
    });

    dialogRef.afterClosed().subscribe(entireresult => {

      console.log(entireresult)
      if(entireresult!=null && entireresult!=undefined) 
        {
          let d = { id: entireresult?.incidentid, name: entireresult?.refno, type: 'object', entityName: 'Incident', department: entireresult?.department.locationname };
          this.componentSelection.emit(d)
        }
      // alert(entireresult)
     
    });
  }

  usernotifications:any;
  filteredNotifications:any
  unreadCount:any;
  // getusernotifications() {
  //   console.log("hehe")
    
  //   this.agentscriptservice.getusernotifications().subscribe((data: any) => {
  //     console.log(data);
  //     this.usernotifications = data;
  //     // Initially show all notifications
  //     this.filteredNotifications = this.usernotifications;
  //     // this.unreadCount =this.userallnotifications.filter(notification => !notification.readmode).length;
  //     // console.log(this.unreadCount)
  //   });

  // }

  // getNotificationsCountOfUnRead()
  // {
  //   this.agentscriptservice.getuserallnotifications().subscribe((data:any)=>
  //     {

  //     }
  //   )
  // }
  calculateUnreadCount() {
    console.log(this.filteredNotifications)
    // this.unreadCount = this.filteredNotifications.filter(notification => !notification.readmode);
    // console.log(this.unreadCount)
  }

  // toggleShowUnread(checked: boolean) {
  //   console.log(checked)
  //   if (checked) {
  //     // alert(checked)
  //     // Filter unread notifications
  //     this.agentscriptservice.filterednotifications = this.usernotifications.filter(notification => !notification.readmode);
  //     console.log(this.filteredNotifications.length)
  //   } else {
  //     // Show all notifications
  //     this.agentscriptservice.filterednotifications = this.usernotifications;
  //   }
  // }
  userallnotifications:any;
  getuserallnotifications()
  {
    this.agentscriptservice.getuserallnotifications().subscribe((data:any)=>
    {
      // console.log(data)
      this.userallnotifications=data;
      // this.unreadCount =this.userallnotifications.filter(notification => !notification.readmode).length;
      // this.filteredNotifications=data;
    })
  }

  markallasread()
  {
    this.agentscriptservice.markallnotificationsread().subscribe((data:any)=>
      {
        console.log(data)
        this.agentscriptservice.getusernotifications()
        this.agentscriptservice.getNotificationsCountOfUnRead()
      })
  }

  notificationscount:any;
  getnotificationscount()
  {
    this.agentscriptservice.getnotificationscount().subscribe((data:any)=>
    {
      console.log(data)
      this.notificationscount=data;
    })
  }

  updatemode(notifyid:any)
  {

    console.log(notifyid)
    let d = { id: notifyid?.incidentid, name: notifyid?.refno, type: 'object', entityName: 'Incident', department: notifyid?.department.locationname };
    this.componentSelection.emit(d)
    // console.log(index)
    this.agentscriptservice.updatereadmode(notifyid).subscribe((data: any) => {
    // this.http.put(this.backendUrl+'updateMode?notifyid='+notifyid.id,{}).subscribe((data:any)=>
    // {
      console.log(data)
      if(data)
      notifyid.readmode=true
      this.agentscriptservice.getuserallnotifications()
    })
    // this.getrefreshuserlist();
    


    const unread = document.querySelector('input[type="checkbox"][id="unreadnotification"]');
          console.log(unread)
          if (unread) {
            (unread as HTMLInputElement).checked = false;
          }


  }


  refreshuserlist:any;
  getrefreshuserlist()
  {
    this.http.get(this.backendUrl+'getNotificationsCount').subscribe((data:any)=>
    {
      // alert(data)
      this.notificationscount=data;
      this.agentscriptservice.getuserallnotifications()
      // this.getusernotifications();

    })
  }

}